import { render, staticRenderFns } from "./Beilagen.vue?vue&type=template&id=61e1f088&scoped=true"
import script from "./Beilagen.vue?vue&type=script&lang=js"
export * from "./Beilagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e1f088",
  null
  
)

export default component.exports